// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PeoplesMapSvg from '@rsuite/icon-font/lib/people/PeoplesMap';
var PeoplesMap = createSvgIcon({
  as: PeoplesMapSvg,
  ariaLabel: 'peoples map',
  category: 'people',
  displayName: 'PeoplesMap'
});
export default PeoplesMap;